/**
 * Luxe Hotel Essentials - 购物车自定义业务逻辑
 * 专门处理多阶梯促销、专属优惠动态计算等轻奢交互
 */
window.LheCartDrawer = {
  // 初始化或重置促销消息
  initPromoMessage: function(container) {
    // 限制在传入的购物车容器内寻找，避免全局交叉污染
    const promoSpan = container ? container.querySelector('#luxe-promo-message') : document.querySelector('#luxe-promo-message');
    if (!promoSpan) return;

    // 1. 如果购物车是空的，保持优雅的智能计算等待动画
    const isCartEmpty = container && container.classList.contains('is-empty');
    if (isCartEmpty) {
      promoSpan.innerHTML = 'Calculating your exclusive hotel-grade privileges<span class="dots">...</span>';
      promoSpan.style.opacity = '0.7';
      return;
    }

    // 2. 如果购物车内有商品，在每次打开或更新数量时，给予一个优雅的 1.2 秒“智能应用”闪烁过程
    // 先让文字产生呼吸感
    promoSpan.style.transition = 'opacity 0.3s ease';
    promoSpan.style.opacity = '0.5';

    setTimeout(() => {
      promoSpan.style.opacity = '1';
    }, 200);
  }
};